import { render, staticRenderFns } from "./Invoices.yaml?vue&type=template&id=5bad8c2d&component"
import script from "./Invoices.yaml?vue&type=script&lang=ts&component"
export * from "./Invoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports